var _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _line, _line2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _circle2, _circle3, _path8, _circle4, _circle5, _path9, _circle6, _circle7, _path0, _circle8, _circle9, _path1, _circle0, _circle1, _path10, _circle10, _circle11, _path11, _circle12, _circle13, _path12, _circle14, _circle15, _path13, _circle16, _circle17, _path14, _circle18, _circle19, _path15, _circle20, _circle21, _path16, _circle22, _circle23, _path17, _circle24, _circle25, _path18, _circle26, _circle27, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _g26, _g27, _g28, _g29;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobalPaymentsIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 600,
    viewBox: "0 0 800 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 600,
    fill: "#133B57",
    fillOpacity: 0.02
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 300,
    rx: 350,
    ry: 250,
    fill: "#133B57",
    fillOpacity: 0.05,
    stroke: "#133B57",
    strokeWidth: 2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 300,
    rx: 350,
    ry: 250,
    stroke: "#133B57",
    strokeWidth: 1,
    strokeOpacity: 0.2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 300,
    rx: 280,
    ry: 200,
    stroke: "#133B57",
    strokeWidth: 1,
    strokeOpacity: 0.2
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 300,
    rx: 210,
    ry: 150,
    stroke: "#133B57",
    strokeWidth: 1,
    strokeOpacity: 0.2
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 400,
    cy: 300,
    rx: 140,
    ry: 100,
    stroke: "#133B57",
    strokeWidth: 1,
    strokeOpacity: 0.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 300,
    x2: 750,
    y2: 300,
    stroke: "#133B57",
    strokeWidth: 1,
    strokeOpacity: 0.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 50,
    x2: 400,
    y2: 550,
    stroke: "#133B57",
    strokeWidth: 1,
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200 150C210 140 240 130 270 135C300 140 320 160 330 180C340 200 345 220 335 230C325 240 300 235 275 230C250 225 225 210 215 190C205 170 190 160 200 150Z",
    fill: "#133B57",
    fillOpacity: 0.15,
    stroke: "#133B57",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250 300C260 290 280 285 300 290C320 295 330 310 335 325C340 340 345 355 335 365C325 375 305 370 285 365C265 360 250 350 245 335C240 320 240 310 250 300Z",
    fill: "#133B57",
    fillOpacity: 0.15,
    stroke: "#133B57",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M400 150C410 140 430 135 450 140C470 145 480 160 485 175C490 190 495 205 485 215C475 225 455 220 435 215C415 210 400 200 395 185C390 170 390 160 400 150Z",
    fill: "#133B57",
    fillOpacity: 0.15,
    stroke: "#133B57",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M400 260C410 250 430 245 450 250C470 255 480 270 485 285C490 300 495 315 485 325C475 335 455 330 435 325C415 320 400 310 395 295C390 280 390 270 400 260Z",
    fill: "#133B57",
    fillOpacity: 0.15,
    stroke: "#133B57",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M520 180C530 170 550 165 570 170C590 175 600 190 605 205C610 220 615 235 605 245C595 255 575 250 555 245C535 240 520 230 515 215C510 200 510 190 520 180Z",
    fill: "#133B57",
    fillOpacity: 0.15,
    stroke: "#133B57",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M580 360C590 350 610 345 630 350C650 355 660 370 665 385C670 400 675 415 665 425C655 435 635 430 615 425C595 420 580 410 575 395C570 380 570 370 580 360Z",
    fill: "#133B57",
    fillOpacity: 0.15,
    stroke: "#133B57",
    strokeWidth: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M230 160C240 150 260 145 280 150C300 155 310 170 315 185C320 200 325 215 315 225C305 235 285 230 265 225C245 220 230 210 225 195C220 180 220 170 230 160Z",
    fill: "#E96543",
    fillOpacity: 0.5,
    stroke: "#E96543",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 175,
    r: 20,
    fill: "#E96543"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 175,
    r: 12,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 175,
    r: 5,
    fill: "#E96543"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M250 175C300 150 350 125 450 150",
    stroke: "#E96543",
    strokeWidth: 3,
    strokeDasharray: "10 5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 15,
    to: 0,
    dur: "2s",
    repeatCount: "indefinite"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 150,
    r: 12,
    fill: "#133B57"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 150,
    r: 6,
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M250 175C350 160 450 145 550 180",
    stroke: "#E96543",
    strokeWidth: 3,
    strokeDasharray: "10 5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 15,
    to: 0,
    dur: "2.3s",
    repeatCount: "indefinite"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 180,
    r: 12,
    fill: "#133B57"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 550,
    cy: 180,
    r: 6,
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M250 175C300 210 350 245 450 270",
    stroke: "#E96543",
    strokeWidth: 3,
    strokeDasharray: "10 5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 15,
    to: 0,
    dur: "2.5s",
    repeatCount: "indefinite"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 270,
    r: 12,
    fill: "#133B57"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 270,
    r: 6,
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M250 175C350 240 450 305 600 380",
    stroke: "#E96543",
    strokeWidth: 3,
    strokeDasharray: "10 5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 15,
    to: 0,
    dur: "3s",
    repeatCount: "indefinite"
  }))), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 380,
    r: 12,
    fill: "#133B57"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 380,
    r: 6,
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M250 175C250 220 250 265 280 310",
    stroke: "#E96543",
    strokeWidth: 3,
    strokeDasharray: "10 5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 15,
    to: 0,
    dur: "1.8s",
    repeatCount: "indefinite"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 310,
    r: 12,
    fill: "#133B57"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 310,
    r: 6,
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M250 175C200 220 150 265 120 330",
    stroke: "#E96543",
    strokeWidth: 3,
    strokeDasharray: "10 5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 15,
    to: 0,
    dur: "2.7s",
    repeatCount: "indefinite"
  }))), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 330,
    r: 12,
    fill: "#133B57"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 330,
    r: 6,
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M250 175C200 250 150 325 180 450",
    stroke: "#E96543",
    strokeWidth: 3,
    strokeDasharray: "10 5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 15,
    to: 0,
    dur: "2.9s",
    repeatCount: "indefinite"
  }))), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 450,
    r: 12,
    fill: "#133B57"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 450,
    r: 6,
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M250 175C300 280 350 385 400 480",
    stroke: "#E96543",
    strokeWidth: 3,
    strokeDasharray: "10 5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 15,
    to: 0,
    dur: "2.6s",
    repeatCount: "indefinite"
  }))), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 480,
    r: 12,
    fill: "#133B57"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 480,
    r: 6,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M250 175C330 260 410 345 500 450",
    stroke: "#E96543",
    strokeWidth: 3,
    strokeDasharray: "10 5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 15,
    to: 0,
    dur: "2.4s",
    repeatCount: "indefinite"
  }))), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 450,
    r: 12,
    fill: "#133B57"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 450,
    r: 6,
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M250 175C350 200 450 225 680 250",
    stroke: "#E96543",
    strokeWidth: 3,
    strokeDasharray: "10 5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 15,
    to: 0,
    dur: "3.2s",
    repeatCount: "indefinite"
  }))), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 680,
    cy: 250,
    r: 12,
    fill: "#133B57"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 680,
    cy: 250,
    r: 6,
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M250 175C350 130 450 85 600 100",
    stroke: "#E96543",
    strokeWidth: 3,
    strokeDasharray: "10 5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 15,
    to: 0,
    dur: "2.8s",
    repeatCount: "indefinite"
  }))), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 100,
    r: 12,
    fill: "#133B57"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 100,
    r: 6,
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M250 175C300 130 350 85 400 80",
    stroke: "#E96543",
    strokeWidth: 3,
    strokeDasharray: "10 5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 15,
    to: 0,
    dur: "1.9s",
    repeatCount: "indefinite"
  }))), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 80,
    r: 12,
    fill: "#133B57"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 80,
    r: 6,
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M250 175C200 140 150 105 100 120",
    stroke: "#E96543",
    strokeWidth: 3,
    strokeDasharray: "10 5"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    from: 15,
    to: 0,
    dur: "2.1s",
    repeatCount: "indefinite"
  }))), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 120,
    r: 12,
    fill: "#133B57"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 120,
    r: 6,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(350, 200) rotate(-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -15,
    width: 50,
    height: 30,
    rx: 4,
    fill: "white",
    stroke: "#133B57",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -10,
    width: 40,
    height: 6,
    rx: 1,
    fill: "#E96543"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: 0,
    width: 25,
    height: 4,
    rx: 1,
    fill: "#133B57",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: 7,
    width: 15,
    height: 4,
    rx: 1,
    fill: "#133B57",
    fillOpacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(480, 320) rotate(10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -15,
    width: 50,
    height: 30,
    rx: 4,
    fill: "white",
    stroke: "#133B57",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -10,
    width: 40,
    height: 6,
    rx: 1,
    fill: "#E96543"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: 0,
    width: 25,
    height: 4,
    rx: 1,
    fill: "#133B57",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: 7,
    width: 15,
    height: 4,
    rx: 1,
    fill: "#133B57",
    fillOpacity: 0.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 250) rotate(-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -15,
    width: 50,
    height: 30,
    rx: 4,
    fill: "white",
    stroke: "#133B57",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -10,
    width: 40,
    height: 6,
    rx: 1,
    fill: "#E96543"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: 0,
    width: 25,
    height: 4,
    rx: 1,
    fill: "#133B57",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: 7,
    width: 15,
    height: 4,
    rx: 1,
    fill: "#133B57",
    fillOpacity: 0.3
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(650, 180) rotate(15)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -25,
    y: -15,
    width: 50,
    height: 30,
    rx: 4,
    fill: "white",
    stroke: "#133B57",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -10,
    width: 40,
    height: 6,
    rx: 1,
    fill: "#E96543"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: 0,
    width: 25,
    height: 4,
    rx: 1,
    fill: "#133B57",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: 7,
    width: 15,
    height: 4,
    rx: 1,
    fill: "#133B57",
    fillOpacity: 0.3
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(520, 400) rotate(-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -20,
    width: 24,
    height: 40,
    rx: 3,
    fill: "white",
    stroke: "#133B57",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -16,
    width: 16,
    height: 28,
    rx: 1,
    fill: "#133B57",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 16,
    r: 2,
    fill: "#133B57",
    fillOpacity: 0.3
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(320, 380) rotate(5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -20,
    width: 24,
    height: 40,
    rx: 3,
    fill: "white",
    stroke: "#133B57",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -16,
    width: 16,
    height: 28,
    rx: 1,
    fill: "#133B57",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 16,
    r: 2,
    fill: "#133B57",
    fillOpacity: 0.3
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 400) rotate(-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -20,
    width: 24,
    height: 40,
    rx: 3,
    fill: "white",
    stroke: "#133B57",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -16,
    width: 16,
    height: 28,
    rx: 1,
    fill: "#133B57",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 16,
    r: 2,
    fill: "#133B57",
    fillOpacity: 0.3
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(600, 150) rotate(10)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -20,
    width: 24,
    height: 40,
    rx: 3,
    fill: "white",
    stroke: "#133B57",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -8,
    y: -16,
    width: 16,
    height: 28,
    rx: 1,
    fill: "#133B57",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 16,
    r: 2,
    fill: "#133B57",
    fillOpacity: 0.3
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(280, 250)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    rx: 3,
    fill: "white",
    stroke: "#E96543",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 -5L5 -5L5 5L-5 5Z",
    fill: "#E96543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 -8L8 -8L8 8L-8 8Z",
    stroke: "#E96543",
    strokeWidth: 1,
    fill: "none"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(380, 350)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    rx: 3,
    fill: "white",
    stroke: "#E96543",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 -5L5 -5L5 5L-5 5Z",
    fill: "#E96543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 -8L8 -8L8 8L-8 8Z",
    stroke: "#E96543",
    strokeWidth: 1,
    fill: "none"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(500, 300)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    rx: 3,
    fill: "white",
    stroke: "#E96543",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 -5L5 -5L5 5L-5 5Z",
    fill: "#E96543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 -8L8 -8L8 8L-8 8Z",
    stroke: "#E96543",
    strokeWidth: 1,
    fill: "none"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(180, 320)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    rx: 3,
    fill: "white",
    stroke: "#E96543",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 -5L5 -5L5 5L-5 5Z",
    fill: "#E96543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 -8L8 -8L8 8L-8 8Z",
    stroke: "#E96543",
    strokeWidth: 1,
    fill: "none"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(600, 220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    rx: 3,
    fill: "white",
    stroke: "#E96543",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 -5L5 -5L5 5L-5 5Z",
    fill: "#E96543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 -8L8 -8L8 8L-8 8Z",
    stroke: "#E96543",
    strokeWidth: 1,
    fill: "none"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 450)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    rx: 3,
    fill: "white",
    stroke: "#E96543",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 -5L5 -5L5 5L-5 5Z",
    fill: "#E96543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 -8L8 -8L8 8L-8 8Z",
    stroke: "#E96543",
    strokeWidth: 1,
    fill: "none"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 450)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    rx: 3,
    fill: "white",
    stroke: "#E96543",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 -5L5 -5L5 5L-5 5Z",
    fill: "#E96543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 -8L8 -8L8 8L-8 8Z",
    stroke: "#E96543",
    strokeWidth: 1,
    fill: "none"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(650, 350)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -15,
    width: 30,
    height: 30,
    rx: 3,
    fill: "white",
    stroke: "#E96543",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5 -5L5 -5L5 5L-5 5Z",
    fill: "#E96543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-8 -8L8 -8L8 8L-8 8Z",
    stroke: "#E96543",
    strokeWidth: 1,
    fill: "none"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(370, 150)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 18,
    fill: "#E96543",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -8V8M-5 -5H5M-5 5H5",
    stroke: "#E96543",
    strokeWidth: 2
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 230)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 18,
    fill: "#E96543",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: -6,
    y: 6,
    fontFamily: "Arial",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#E96543"
  }, "\u20AC"))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(520, 150)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 18,
    fill: "#E96543",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: -6,
    y: 6,
    fontFamily: "Arial",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#E96543"
  }, "\xA5"))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(410, 400)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 18,
    fill: "#E96543",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: -6,
    y: 6,
    fontFamily: "Arial",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#E96543"
  }, "\xA3"))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 100)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 18,
    fill: "#E96543",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: -6,
    y: 6,
    fontFamily: "Arial",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#E96543"
  }, "$"))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 200)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 18,
    fill: "#E96543",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: -6,
    y: 6,
    fontFamily: "Arial",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#E96543"
  }, "\u20BF"))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(650, 250)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 18,
    fill: "#E96543",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: -6,
    y: 6,
    fontFamily: "Arial",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#E96543"
  }, "\u20B9"))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(550, 450)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 18,
    fill: "#E96543",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: -6,
    y: 6,
    fontFamily: "Arial",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#E96543"
  }, "$"))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200, 500)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 18,
    fill: "#E96543",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: -6,
    y: 6,
    fontFamily: "Arial",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#E96543"
  }, "\u20AC"))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 400)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 18,
    fill: "#E96543",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: -6,
    y: 6,
    fontFamily: "Arial",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#E96543"
  }, "\xA5"))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(700, 400)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 18,
    fill: "#E96543",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: -6,
    y: 6,
    fontFamily: "Arial",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#E96543"
  }, "\xA3"))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M330 180C340 190 350 200 360 210",
    stroke: "#E96543",
    strokeWidth: 2,
    strokeOpacity: 0.7
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M340 190C350 200 360 210 370 220",
    stroke: "#E96543",
    strokeWidth: 2,
    strokeOpacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M350 200C360 210 370 220 380 230",
    stroke: "#E96543",
    strokeWidth: 2,
    strokeOpacity: 0.3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M330 250C340 270 350 290 360 310",
    stroke: "#E96543",
    strokeWidth: 2,
    strokeOpacity: 0.7
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M340 260C350 280 360 300 370 320",
    stroke: "#E96543",
    strokeWidth: 2,
    strokeOpacity: 0.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M350 270C360 290 370 310 380 330",
    stroke: "#E96543",
    strokeWidth: 2,
    strokeOpacity: 0.3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M400 200C420 220 440 240 460 260",
    stroke: "#E96543",
    strokeWidth: 2,
    strokeOpacity: 0.7
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M410 210C430 230 450 250 470 270",
    stroke: "#E96543",
    strokeWidth: 2,
    strokeOpacity: 0.5
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M420 220C440 240 460 260 480 280",
    stroke: "#E96543",
    strokeWidth: 2,
    strokeOpacity: 0.3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M200 350C220 370 240 390 260 410",
    stroke: "#E96543",
    strokeWidth: 2,
    strokeOpacity: 0.7
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M210 360C230 380 250 400 270 420",
    stroke: "#E96543",
    strokeWidth: 2,
    strokeOpacity: 0.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M220 370C240 390 260 410 280 430",
    stroke: "#E96543",
    strokeWidth: 2,
    strokeOpacity: 0.3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M500 350C520 370 540 390 560 410",
    stroke: "#E96543",
    strokeWidth: 2,
    strokeOpacity: 0.7
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M510 360C530 380 550 400 570 420",
    stroke: "#E96543",
    strokeWidth: 2,
    strokeOpacity: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M520 370C540 390 560 410 580 430",
    stroke: "#E96543",
    strokeWidth: 2,
    strokeOpacity: 0.3
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -20,
    width: 40,
    height: 40,
    rx: 5,
    fill: "#133B57",
    fillOpacity: 0.05,
    stroke: "#E96543",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 -10L10 -10L10 10L-10 10Z",
    stroke: "#E96543",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#E96543",
    fillOpacity: 0.3
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(720, 80)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -20,
    width: 40,
    height: 40,
    rx: 5,
    fill: "#133B57",
    fillOpacity: 0.05,
    stroke: "#E96543",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 -10L10 -10L10 10L-10 10Z",
    stroke: "#E96543",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#E96543",
    fillOpacity: 0.3
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 520)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -20,
    width: 40,
    height: 40,
    rx: 5,
    fill: "#133B57",
    fillOpacity: 0.05,
    stroke: "#E96543",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 -10L10 -10L10 10L-10 10Z",
    stroke: "#E96543",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#E96543",
    fillOpacity: 0.3
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(720, 520)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -20,
    y: -20,
    width: 40,
    height: 40,
    rx: 5,
    fill: "#133B57",
    fillOpacity: 0.05,
    stroke: "#E96543",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-10 -10L10 -10L10 10L-10 10Z",
    stroke: "#E96543",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#E96543",
    fillOpacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalPaymentsIllustration);
export default __webpack_public_path__ + "static/media/global-payments-illustration.69c1762e443b13b3ce68d715f5f1fa03.svg";
export { ForwardRef as ReactComponent };